var userAgent = require('../../useragent');

var docMode = function() {
  return document ? document.documentMode : undefined;
};

var version = function() {
  var re = /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/;
  var arr = re.exec(userAgent.userAgent);
  var v = arr ? arr[1] : '';

  var mode = docMode();
  if (mode > parseFloat(version)) {
    return String(mode);
  }

  return v;
};

module.exports = function(cb) {
  if (version() >= 10) {
    try {
      if (!window.indexedDB) {
        cb(true);
      } else {
        cb(false);
      }
    } catch (ex) {
      cb(false);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/incognito/trident.js
// module id = 21
// module chunks = 1 3